import React from 'react';
import Hero from '../components/Hero';
import MobileHero from '../components/MobileHero';
import CoachingBanner from '../components/CoachingBanner';
import KitchenSection from '../components/KitchenSection';
import SnookerSection from '../components/SnookerSection';

const HomePage: React.FC = () => {
  return (
    <>
      <Hero />
      <MobileHero />
      <CoachingBanner />
      <KitchenSection />
      <SnookerSection showGallery={false} />
      
      {/* Reservation CTA Section */}
      <section className="relative py-20 bg-primary-black overflow-hidden">
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary-gold opacity-5 rounded-full blur-3xl"></div>
        
        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-primary-gold mb-6 font-display">
            Ready to Book?
          </h2>
          <p className="text-gray-300 text-lg mb-8">
            Reserve your table at our restaurant or book a snooker/pool table today
          </p>
          <a 
            href="/book" 
            className="inline-block bg-primary-gold text-primary-black px-12 py-4 rounded-full font-semibold text-lg hover:bg-primary-black hover:text-primary-gold hover:border-2 hover:border-primary-gold transition-all"
            aria-label="Make a reservation for restaurant or book a table"
          >
            Make a Reservation
          </a>
        </div>
      </section>
    </>
  );
};

export default HomePage;
